import { DataMessage } from '@ouster/webviz';

import { applyRgbAutoExposure } from '../utils/rgbAutoExposure';

/**
 * Keep raw RGB in the frame payload and derive the point-cloud RGB coloring
 * variant at preprocessing time. This avoids storing duplicate corrected RGB
 * buffers for the same frame.
 *
 * @param msg - Data message for the current frame.
 * @param coloringMode - Active point-cloud coloring mode.
 * @param isAutoLevelsOn - Whether the Auto-Levels toggle is enabled.
 * @returns A message with the appropriate RGB channel data for the toggle state.
 */
export const applyPointCloudRgbAutoExposure = (
  msg: DataMessage,
  coloringMode: string,
  isAutoLevelsOn: boolean
): DataMessage => {
  if (!msg.rgbChannels?.includes(coloringMode)) {
    return msg;
  }

  return applyRgbAutoExposure(
    msg,
    coloringMode,
    isAutoLevelsOn,
    `point-cloud:${coloringMode}`
  );
};
